import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import LandingPage from './components/LandingPage';
import About from './pages/About';
import Services from './pages/Services';
import Product from './pages/Product';
import Contactus from './pages/Contactus';

// Products sub-pages
import HisPage from './pages/HisPage';
import EhrPage from './pages/EhrPage';
import RcmPage from './pages/RcmPage';
import LimsPage from './pages/LimsPage';

// Services sub-pages
import Medical from "./pages/Medical";
import Analysis from "./pages/Analysis";
import Detection from "./pages/Detection";

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        {/* Main pages */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/products" element={<Product />} />
        <Route path="/contact" element={<Contactus />} />

        {/* Services sub-pages */}
        <Route path="/analysis" element={<Analysis />} />
        <Route path="/detection" element={<Detection />} />
        <Route path="/medical" element={<Medical />} />

        {/* Products sub-pages */}
        <Route path="/his" element={<HisPage />} />
        <Route path="/ehr" element={<EhrPage />} />
        <Route path="/rcm" element={<RcmPage />} />
        <Route path="/lims" element={<LimsPage />} />
      </Routes>
    </Router>
  );
}

export default App;
